import React from 'react'
import { zipObject, upperFirst, camelCase } from 'lodash'
import * as CryptoCoinsIcon from 'react-cryptocoins'
import Circle from './Circle'

const cryptoCoinsIconMapping = {
  ADC: 'ADC',
  AEON: 'AEON',
  AMP: 'AMP',
  ANC: 'ANC',
  ARCH: 'ARCH',
  ARDR: 'ARDR',
  AUR: 'AUR',
  BANX: 'BANX',
  BAT: 'BAT',
  BAY: 'BAY',
  BC: 'BC',
  BCN: 'BCN',
  BFT: 'BFT',
  BRK: 'BRK',
  BRX: 'BRX',
  BSD: 'BSD',
  BTA: 'BTA',
  BTC: 'BTC',
  BTCD: 'BTCD',
  BTS: 'BTS',
  CLAM: 'CLAM',
  CLOAK: 'CLOAK',
  DAO: 'DAO-alt',
  DASH: 'DASH',
  DCR: 'DCR',
  DCT: 'DCT',
  DGB: 'DGB',
  DGD: 'DGD',
  DMD: 'DMD',
  DOGE: 'DOGE',
  EMC: 'EMC',
  EOS: 'EOS-alt',
  ERC: 'ERC',
  ETC: 'ETC-alt',
  ETH: 'ETH',
  FC2: 'FC2',
  FCT: 'FCT',
  FLO: 'FLO',
  FRK: 'FRK',
  FTC: 'FTC',
  GAME: 'GAME',
  GDC: 'GDC',
  GEMZ: 'GEMZ',
  GLD: 'GLD-alt',
  GNO: 'GNO',
  GNT: 'GNT-alt',
  GOLOS: 'GOLOS',
  GRC: 'GRC',
  GRS: 'GRS',
  HEAT: 'HEAT',
  ICN: 'ICN-alt',
  IFC: 'IFC',
  INCNT: 'INCNT',
  IOC: 'IOC',
  IOTA: 'IOTA',
  JBS: 'JBS',
  KMD: 'KMD',
  KOBO: 'KOBO',
  KORE: 'KORE',
  LBC: 'LBC-alt',
  LDOGE: 'LDOGE',
  LISK: 'LISK',
  LTC: 'LTC',
  MAID: 'MAID',
  MCO: 'MCO',
  MINT: 'MINT',
  MONA: 'MONA',
  MRC: 'MRC',
  MSC: 'MSC',
  MTR: 'MTR',
  MUE: 'MUE',
  NBT: 'NBT',
  NEO: 'NEO',
  NEOS: 'NEOS',
  NEU: 'NEU',
  NLG: 'NLG',
  NMC: 'NMC',
  NOTE: 'NOTE',
  NVC: 'NVC',
  NXT: 'NXT',
  OK: 'OK',
  OMG: 'OMG-alt',
  OMNI: 'OMNI',
  OPAL: 'OPAL',
  PART: 'PART-alt',
  PIGGY: 'PIGGY',
  PINK: 'PINK',
  PIVX: 'PIVX',
  POT: 'POT',
  PPC: 'PPC',
  QRK: 'QRK',
  RADS: 'RADS-alt',
  RBIES: 'RBIES',
  RBT: 'RBT',
  RBY: 'RBY',
  RDD: 'RDD',
  REP: 'REP',
  RISE: 'RISE-alt',
  SAR: 'SAR',
  SCOT: 'SCOT',
  SDC: 'SDC',
  SIA: 'SIA',
  SJCX: 'SJCX',
  SLG: 'SLG',
  SLS: 'SLS',
  SNRG: 'SNRG',
  START: 'START',
  STEEM: 'STEEM',
  STR: 'STR',
  STRAT: 'STRAT',
  SWIFT: 'SWIFT',
  SYNC: 'SYNC',
  SYS: 'SYS',
  TRIG: 'TRIG',
  TX: 'TX',
  UBQ: 'UBQ-alt',
  UNITY: 'UNITY',
  USDT: 'USDT',
  VIOR: 'VIOR',
  VNL: 'VNL',
  VPN: 'VPN',
  VRC: 'VRC',
  VTC: 'VTC',
  WAVES: 'WAVES',
  XAI: 'XAI',
  XBS: 'XBS',
  XCP: 'XCP',
  XEM: 'XEM',
  XMR: 'XMR',
  XPM: 'XPM',
  XRP: 'XRP',
  XTZ: 'XTZ',
  XVG: 'XVG',
  YBC: 'YBC',
  ZEC: 'ZEC-alt',
  ZEIT: 'ZEIT',
}

const SvgIcons = zipObject(
  Object.keys(cryptoCoinsIconMapping),
  Object.keys(cryptoCoinsIconMapping).map(n => props => {
    const Icon =
      CryptoCoinsIcon[upperFirst(camelCase(cryptoCoinsIconMapping[n]))]
    return <Icon {...props} />
  })
)

export const CurrenciesIcon = ({ currency, ...props }) => {
  const Icon = SvgIcons[currency] || IconDefault(currency)
  return <Icon {...props} />
}

const IconDefault = currency => props => <Circle value={currency} {...props} />



// WEBPACK FOOTER //
// ./src/assets/currencies/index.js